import * as React from "react";
import { ILayoutProps, StateRoot } from "../../Models";
import AdminMenu from "../Layout/Admin/AdminMenu";
import DownloadMenu from "../Layout/Search/DownloadMenu";
import Header from "../Layout/Header";
import Disclaimer from "../../Components/Layout/Details/Disclaimer";
import { YAMMER_FEEDBACK_URL } from "../../Constants";
import salesInfoStore from "../../Store/SalesInfoStore";
import { userStore } from "../../Store/userStore";

export default function (Component: any): any {
    function Layout(props: ILayoutProps) {
        const mobileMenuOpen = salesInfoStore((s) => s.mobileMenuOpen);
        const mobileSearchOpen = salesInfoStore((s) => s.mobileSearchOpen);
        const toggleMobileMenu = salesInfoStore((s) => s.toggleMobileMenu);
        const toggleMobileSearch = salesInfoStore((s) => s.toggleMobileSearch);
        const isAdminUser = userStore((s) => s.user?.isAdminUser);
        function mobileClasses(baseClass: string): string {
            let className: string = baseClass;

            if (mobileMenuOpen || mobileSearchOpen) {
                className += ` ${baseClass}--mobile-layout-open`;
            }
            if (mobileMenuOpen) {
                className += ` ${baseClass}--mobile-menu-open`;
            }
            if (mobileSearchOpen) {
                className += ` ${baseClass}--mobile-search-open`;
            }

            return className;
        }

        function handleMobileRedirect(): void {
            if (props.location.pathname === "/search") {
                props.history.push("/");
            }
        }

        function onToggleMobileMenu(): void {
            handleMobileRedirect();
            toggleMobileMenu();
        }

        function onToggleMobileSearch(): void {
            handleMobileRedirect();
            toggleMobileSearch();
        }

        // render(): JSX.Element {
        return (
            <div className={mobileClasses("wrapper")}>
                <Disclaimer />

                {/* <Notification  used for showing Error, now with toast this can be removed 
                        errors={this.props.errors}
                        confirmations={[]}
                        infos={[]}
                        removeError={this.props.removeError}
                        removeAllErrors={this.props.removeAllErrors}
                    /> */}

                <Header
                    yammerUri={YAMMER_FEEDBACK_URL}
                    onToggleMobileMenu={onToggleMobileMenu}
                    onToggleMobileSearch={onToggleMobileSearch}
                />

                {isAdminUser && <AdminMenu />}
                <DownloadMenu />

                <Component {...props} />
            </div>
        );
    }
    return Layout;
}
